import { imageObjectType } from './imageObjectType';
import { organizationType } from './organizationType';
import { conf } from '../../configService';
import { removeEmptyProperties } from '../../../utils/objectUtils';
import { breadcrumbListType } from './breadcrumbListType';

// @see https://schema.org/WebPage
export const webPageType = content =>
  removeEmptyProperties({
    '@type': 'WebPage',
    '@id': `https://${conf.canonicalDomain}${content.url?.path}`,
    name: content.title,
    description: content.promoSummary,
    url: `https://${conf.canonicalDomain}${content.url?.path}`,
    image: imageObjectType(content.promoImage?.[0]?.entity),
    keywords: content.metaTags?.keywords,
    publisher: organizationType(),
    isAccessibleForFree: 'True',
    breadcrumb: breadcrumbListType(content)
  });
